import * as React from 'react';
import {cn} from '../../lib/cn';

export type LegacyInputProps = React.ComponentProps<'input'>;

export const LegacyInput = React.forwardRef<HTMLInputElement, LegacyInputProps>(
  ({className, type, readOnly, ...props}, ref) => (
    <input
      ref={ref}
      type={type}
      readOnly={readOnly}
      className={cn(
        'flex h-10 w-[293px] rounded-[var(--chekin-radius-input)] border border-[var(--chekin-color-gray-3)] bg-[var(--chekin-color-white)] px-3 py-2 text-base text-[var(--chekin-color-brand-navy)]',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'placeholder:text-base placeholder:font-medium placeholder:text-[var(--chekin-color-gray-2)]',
        'disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        !readOnly && 'placeholder-shown:bg-[var(--chekin-color-surface-input-empty)]',
        !readOnly &&
          'focus-visible:outline-none focus-visible:shadow-[var(--chekin-shadow-focus)]',
        readOnly && 'cursor-default outline-none',
        className,
      )}
      {...props}
    />
  ),
);

LegacyInput.displayName = 'LegacyInput';
